const privateNotes = {
  'notes': 'required'
};

const caseActions = {
  'controlNumber': 'required'
};

export {
  privateNotes,
  caseActions
};